import script from "./GlobalMessages.vue?vue&type=script&lang=js"
export * from "./GlobalMessages.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__